'use client';

import { ComponentProps, useEffect, useRef } from 'react';

export function useDebugChangedProps(props: ComponentProps<any>): void {
  const ref = useRef(props);
  useEffect(() => {
    const changedProps = Object.entries(props).reduce((object: { [key: string]: unknown }, [key, value]) => {
      if (ref.current[key] !== value) {
        object[key] = [ref.current[key], value];
      }
      return object;
    }, {});
    if (Object.keys(changedProps).length > 0) {
      console.log('Changed props:', changedProps);
    }
    ref.current = props;
  });
}
